import toastr from "toastr"
import "toastr/build/toastr.min.css"

export const showNoDataIndication = (isLoading) => {
    if(isLoading){
      return (
        <div className="text-center my-3">
          <div className="text-success">
            <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
            Loading...
          </div>
        </div>
      )
    }
    else{
      return <div className="text-center my-3">- No transactions found -</div>
    }
}

export function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}

export function getNextNonDisabledField(currentIndex , form){
  //console.log('[currentIndex + 1]',currentIndex + 1)
  //console.log('form.elements[currentIndex]',form.elements[currentIndex])
  if(form.elements[currentIndex + 1].disabled || form.elements[currentIndex + 1].type == 'checkbox'){
    for (let index = currentIndex+1; index < form.elements.length; index++) {
      if(!form.elements[index].disabled && (form.elements[index].type != 'checkbox')){
        return index
      }
    }
  }
  else{
    return currentIndex+1;
  }
  return form.elements.length-1
}

export function showSuccessToast(msg) {
    toastr.options = {
        positionClass: "toast-top-right",
        timeOut: 3000,
        closeButton: false,
        debug: false,
        progressBar: false,
        preventDuplicates: false,
        newestOnTop: true,
        showEasing: 'swing',
        hideEasing: 'linear',
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut',
        showDuration: 300,
        hideDuration: 1000
    }
    toastr.success(msg, 'Success')
}

export function showCloseableToast(message, position,toastType) {
    toastr.options = {
        positionClass: "toast-"+position, //top/bottom-left/right/center/full-width, 
        timeOut: 2500,
        closeButton: true,
        debug: false,
        progressBar: true,
        preventDuplicates: false,
        newestOnTop: true,
        showEasing: 'swing',
        hideEasing: 'linear',
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut',
        showDuration: 300,
        hideDuration: 1000
    }
    if (toastType === "info") toastr.info(message, "Info")
    else if (toastType === "warning") toastr.warning(message, "Warning")
    else if (toastType === "error") toastr.error(message, "Alert")
    else toastr.success(message, "Success")
}

export function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export function getSgstArray(salesRows){
    let sgstArray = []
    salesRows.forEach(each => {
    if(Number(each["sgstpercentage"]) > 0){
        let filteredsgst =  sgstArray.filter(each1 => Number(each1.tax) == Number(each["sgstpercentage"]))
        if(filteredsgst && filteredsgst.length > 0){
            sgstArray = sgstArray.map(eachMapItem => {
            if(Number(eachMapItem.tax) == Number(each["sgstpercentage"])){
                return {
                ...eachMapItem,
                taxableamount : Number(eachMapItem.taxableamount) + Number(each["productgrosswithouttax"]),
                taxamount : Number(eachMapItem.taxamount) + Number(each["productsgst"])
                }
            }
            else{
                return eachMapItem
            }
            })
        }
        else{
            sgstArray.push({
            tax: each["sgstpercentage"],
            taxamount: each["productsgst"],
            taxableamount : each["productgrosswithouttax"]
            })
        }
        }
    })
    return sgstArray
}

export function getCgstArray(salesRows){
    let cgstArray = []
    salesRows.forEach(each => {
        if(Number(each["cgstpercentage"]) > 0){
            let filteredcgst =  cgstArray.filter(each1 => Number(each1.tax) == Number(each["cgstpercentage"]))
            if(filteredcgst && filteredcgst.length > 0){
              cgstArray = cgstArray.map(eachMapItem => {
                if(Number(eachMapItem.tax) == Number(each["cgstpercentage"])){
                  return {
                    ...eachMapItem,
                    taxableamount : Number(eachMapItem.taxableamount) + Number(each["productgrosswithouttax"]),
                    taxamount : Number(eachMapItem.taxamount) + Number(each["productcgst"])
                  }
                }
                else{
                  return eachMapItem
                }
              })
            }
            else{
              cgstArray.push({
                tax: each["cgstpercentage"],
                taxamount: each["productcgst"],
                taxableamount : each["productgrosswithouttax"]
              })
            }
          }
    })
    return cgstArray
}

export function getIgstArray(salesRows){
    let igstArray = []
        salesRows.forEach(each => {
        if(Number(each["igstpercentage"]) > 0){
            let filteredigst =  igstArray.filter(each1 => Number(each1.tax) == Number(each["igstpercentage"]))
            if(filteredigst && filteredigst.length > 0){
              igstArray = igstArray.map(eachMapItem => {
                if(Number(eachMapItem.tax) == Number(each["igstpercentage"])){
                  return {
                    ...eachMapItem,
                    taxableamount : Number(eachMapItem.taxableamount) + Number(each["productgrosswithouttax"]),
                    taxamount : Number(eachMapItem.taxamount) + Number(each["productigst"])
                  }
                }
                else{
                  return eachMapItem
                }
              })
            }
            else{
              igstArray.push({
                tax: each["igstpercentage"],
                taxamount: each["productigst"],
                taxableamount : each["productgrosswithouttax"]
              })
            }
          }
    })
    return igstArray
}